export interface LegalSectionMeta {
  id: string;
  label: string;
  description: string;
  icon: string;
  path: string;
}

export const legalSections: LegalSectionMeta[] = [
  {
    id: "terms",
    label: "Términos de uso",
    description: "Condiciones del servicio, intermediación y normas de publicación.",
    icon: "ri-file-list-3-line",
    path: "/legal/terms",
  },
  {
    id: "privacy",
    label: "Política de privacidad",
    description: "Cómo recopilamos, usamos y protegemos tus datos personales.",
    icon: "ri-shield-keyhole-line",
    path: "/legal/privacy",
  },
  {
    id: "cookies",
    label: "Política de cookies",
    description: "Tipos de cookies que usamos y cómo puedes controlarlas.",
    icon: "ri-radar-line",
    path: "/legal/cookies",
  },
  {
    id: "community",
    label: "Normas de la comunidad",
    description: "Reglas de convivencia, publicación y consecuencias de incumplirlas.",
    icon: "ri-team-line",
    path: "/legal/community",
  },
];